<template lang="pug">
  #firstOrder
    tmp-order-header(v-if="$route.meta.tmpOrder")
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      b-table-simple.mx-auto.pt-2.mt-2.rounded.text-center.stepBar.step4(v-if="$route.meta.activeStep", :fixed="true")
        b-tbody.font-weight-bold
          b-tr
            b-td.step(:class="this.$route.meta.activeStep === 'plan' ? 'current' : ''") プラン内容の選択
            b-td.step(:class="this.$route.meta.activeStep === 'neo' ? 'current' : ''") サービス内容の入力
            b-td.step(:class="this.$route.meta.activeStep === 'customer' ? 'current' : ''") お客様情報の入力
            b-td.step(:class="this.$route.meta.activeStep === 'confirm' ? 'current' : ''") 入力内容の確認
            b-td.step(:class="this.$route.meta.activeStep === 'finish' ? 'current' : ''") 申込完了
      router-view.mx-auto.form-box(v-model="regist_data")
</template>

<script>
import Api from "@/repositories/api";
import Loading from '@/components/Loading';
import TmpOrderHeader from "@/components/firstOrder/TmpOrderHeader";

const t201TmpOrderRepository = Api.get("t201TmpOrder")
export default {
  name: "firstOrder",
  components: {
    Loading,
    TmpOrderHeader,
  },
  data() {
    return {
      // 登録する入力内容
      regist_data: {
        // プラン
        plan_name: null,
        plan_user: null,
        // desknet'sNEO
        app_suite_user: null,
        web_conferencing: null,
        option_service: false,
        option_room_mgr: false,
        option_expense_settlement: false,
        clouza_check: false,
        clouza_input: null,
        clouza_company_code: null,
        paid_leave_option: false,
        option_disk: false,
        option_disk_size: 1,
        option_sync: false,
        option_sync_input: null,
        option_dn_drive: false,
        option_dn_drive_disk_size: 1,
        security_option: false,
        basic_auth: false,
        basic_auth_user: "",
        basic_auth_password: "",
        basic_auth_ip: "",
        ip_restrictions: false,
        ip_restrictions_ip: "",
        secure_browser: false,
        secure_browser_terminal: '01',
        secure_browser_device: null,
        secure_browser_ip: "",
        client_auth: false,
        client_auth_input: null,
        client_auth_ip: "",
        mail_service: false,
        web_arena: false,
        web_arena_domain: "",
        web_arena_input: null,
        cyber: false,
        cyber_input: null,
        cyber_capacity: "00",
        cyber_option: [],
        cyber_keep_period: "00",
        mail_security_service: false,
        mailgates_domain: "",
        mailgates_input: null,
        mailgates_option: [],
        sub_domain: "",
        migration: false,
        migration_url: "",
        // ChatLuck
        chat_option_service: false,
        chat_option_disk: false,
        chat_option_disk_size: 1,
        chat_security_option: false,
        chat_basic_auth: false,
        chat_basic_auth_user: "",
        chat_basic_auth_password: "",
        chat_basic_auth_ip: "",
        chat_ip_restrictions: false,
        chat_ip_restrictions_ip: "",
        chat_sub_domain: "",
        chat_migration: false,
        chat_migration_url: "",
        // desknet's NEO、ChatLuck共通
        estimate: "",
        remarks: "",
        preferred_date: "",
        migration_date: "",
        migration_time_from: null,
        migration_time_to: null,
        provision_check : false,
        // お客様情報
        company_name: "",
        foreign_company_flg: false,
        company_kana: "",
        lbc_office_code: "",
        president_name: "",
        president_kana: "",
        department: "",
        person_name: "",
        person_kana: "",
        postal_code: "",
        prefecture: "",
        city: "",
        address1: "",
        address2: "",
        phone_number: "",
        fax_number: "",
        e_mail: "",
        token: "",
        contract_type: 0,
        payment_method: 0,
        bill_company_name: "",
        bill_company_kana: "",
        bill_department: "",
        bill_president_name: "",
        bill_president_kana: "",
        bill_postal_code: "",
        bill_prefecture: "",
        bill_city: "",
        bill_address1: "",
        bill_address2: "",
        bill_phone_number: "",
        bill_fax_number: "",
        bill_e_mail: "",
        re_bill_e_mail: "",
        password: "",
        re_password: "",
        // 読み込み中フラグ
        isLoading: false
      },
    }
  },
  created () {
    //------------------------------
    // 仮申込メールアドレスを画面に埋め込む
    //------------------------------
    // 仮申込以外の画面で仮申込トークンがない場合
    if (this.$route.meta.tmpOrder !== true && (typeof this.regist_data.token !== "string" || this.regist_data.token.length <= 0)) {
      // 読み込み中
      this.isLoading = true;

      // クエリパラメータから仮申込トークン取得
      const sToken = this.$route.query.token;

      // 仮申し込み情報取得処理を呼ぶ
      t201TmpOrderRepository.get(sToken)
      // 仮申し込み情報取得成功
      .then((response) => {
        // Vueのデータに仮申し込み情報追加
        this.regist_data.token = response.data.data.order_token;     // 仮申込トークン
        this.regist_data.e_mail = response.data.data.tmp_order_mail; // メールアドレス
      })
      // 失敗
      .catch((error) => {
        // 内部エラーの場合はシステムエラー画面へ遷移する
        if (error.response.status >= 500) {
          // 仮申し込み処理は専用のシステムエラー画面へ
          this.$router.push({
            name: "TmpSystemError",
            params: {
              error_msg: "画面表示処理"
            }
          })
        }
        // 仮申込関連のエラーの場合
        this.$router.push({
          name: "RelatedTmpOrder",
          params: {
            // 仮申込のエラーメッセージは一つなので添字決め打ち
            error_msg: error.response.data.error_list[0].error_msg
          }
        })
      })
      .finally(() => [
        // 読み込み完了
        this.isLoading = false
      ])
    }

    // 試使用環境URL用の申し込み種別を取得
    let sTrialType = this.$route.query.trial_type;

    // 試使用環境URL用の試使用IDを取得する
    let sTrialId = this.$route.query.trial_id;

    // desknet'sNEOのお申し込みの場合
    if (sTrialType === '0') {
      // 試使用IDが存在する場合
      if (typeof sTrialId !== 'undefined') {
        // 試使用環境URLの記入欄に初期値を設定する
        this.regist_data.migration_url = 'https://dn06110.dncloudtrial.com/cgi-bin/' + sTrialId + '/dneo/dneo.cgi'
      }
    }
    // ChatLuckのお申し込みの場合
    else {
      // 試使用IDが存在する場合
      if (typeof sTrialId !== 'undefined') {
        // 試使用環境URLの記入欄に初期値を設定する
        this.regist_data.chat_migration_url = 'https://trial-v0r3.chatluck.net/cgi-bin/' + sTrialId + 'chatlk/chat.cgi'
      }
    }
  }
}
</script>

<style scoped>
/* step */
.stepBar {
  position: relative;
  list-style: none;
  margin: 0 0 0;
  padding: 0;
  max-width: 1200px;
  overflow: hidden;
  text-align: center;
  *zoom: 1;
  clear: both;
}
.stepBar .step.current {
  color: #FFF;
  background-color: #4f81bd;
}
.stepBar .step {
  position: relative;
  float: left;
  display: inline-block;
  line-height: 46px;
  padding: 0 40px 0 20px;
  background-color: #BBB;
  box-sizing: border-box;
  color: #FFFFFF;
  border-top: 0px;
}
.stepBar .step:before {
  position: absolute;
  padding: 12px;
  left: -15px;
  display: block;
  content: '';
  background-color: #BBB;
  border-left: 4px solid #FFF;
  width: 23px;
  height: 23px;
  bottom: 0;
  -webkit-transform: skew(-30deg);
  transform: skew(-30deg);
}
.stepBar .step:after {
  position: absolute;
  left: -15px;
  display: block;
  content: '';
  background-color: #BBB;
  border-left: 4px solid #FFF;
  width: 23px;
  height: 23px;
  top: 0;
  -webkit-transform: skew(30deg);
  transform: skew(30deg);
}
.stepBar .step:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.stepBar .step:first-child:before, .stepBar .step:first-child:after {
  content: none;
}
.stepBar .step:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.stepBar .step.current:before, .stepBar .step.current:after {
  background-color: #4f81bd;
}
.stepBar.step4 .step {
  width: 20%;
}
.stepBar.step4 .step:last-child {
  width: 19%;
}
.stepBar br {
  display: none;
}
.form-box {
  max-width: 1200px;
}
</style>